<template>
	<div class="address-wrap">
		<form action="">
			<div class="form-wrap">
				<div class="list">
					<label for="">收货人</label>
					<input type="text" v-model="dataList.receiver" id="receiver" />
				</div>
				<div class="list">
					<label for="">联系电话</label>
					<input type="text" v-model="dataList.telephone" id="telephone" />
				</div>
				<div class="list pick-area">
					<div>
						<label for="">所在地区</label>

						<!-- <input type="text" :value="dataList.area" name="area" id="area" disabled="disabled" /> -->
					</div>
					<div class="flex-wrap" @click="showPopup()">
						<span>{{ dataList.area }}</span>
						<Icon class="icon" :img="require('../../assets/c_icon.png')" />
					</div>
				</div>
				<div class="list">
					<label for="">详细地址</label>
					<input type="text" v-model="dataList.detail" ref="detail" id="detail" />
				</div>
			</div>
		</form>

		<div class="set-default">
			<van-cell center title="设为默认地址">
				<template #right-icon>
					<van-switch size="20px" v-model="cellChecked" active-color="#FF3333" border="false" />
				</template>
			</van-cell>
		</div>

		<div class="submit-btn" @click="onSubmit()">保存收货地址</div>
		<template v-if="ui.isIE">
			<Popup v-model="showArea" position="bottom">
				<SimplePicker
					ref="areaPick"
					:columns="columns"
					title="选择区域"
					@cancel="onCancel"
					@confirm="onConfirm"
					@change="onChange"
					value-key="code"
				/>
			</Popup>
		</template>
		<template v-else>
			<Popup v-model="showArea" position="bottom">
				<Picker
					ref="areaPick"
					:columns="columns"
					show-toolbar
					title="选择区域"
					@cancel="onCancel"
					@confirm="onConfirm"
					@change="onChange"
					value-key="name"
				/>
			</Popup>
		</template>
	</div>
</template>

<script>
import Vue from 'vue';
import api from '../../api';
import ActionButton from '@/components/products/form/ActionButton';
import { SwitchCell, Area, Popup, Picker } from 'vant';
Vue.use(SwitchCell, Area);

function AddressItem(name, code) {
	this.name = name;
	this.code = code;
}

// function onchange(v) {
// 	console.log(v)
// }

AddressItem.prototype.toString = function() {
	return this.name;
};
export default {
	title: '编辑收货地址',
	bodyClass: 'gray-bg',
	components: {
		ActionButton,
		Popup,
		Picker,
	},
	computed: {
		// checked () {
		// 	return this.dataList.default
		// }
	},
	data() {
		return {
			pageTitle: '',
			addressId: '',
			dataList: '',
			showArea: false,
			cellChecked: '',
			ui: {
				show: false,
				isIE: false,
			},
			loading: true,
			columns: [
				{
					values: [],
					className: 'column1',
					defaultIndex: 0,
				},
				{
					values: [],
					className: 'column2',
					defaultIndex: 0,
				},
				{
					values: [],
					className: 'column3',
					defaultIndex: 0,
				},
				{
					values: [],
					className: 'column4',
					defaultIndex: 0,
				},
			],
			info: {
				receiver: '',
				telephone: '',
				area: '',
				sArea: '',
				detail: '',
				ids: '',
			},
			// index: {
			// 	provinceIndex:0,
			// 	cityIndex:0
			// },
			initialIds: [],
		};
	},
	methods: {
		onchange() {
			console.log(this);
		},
		setTitle() {
			document.title = this.pageTitle;
		},
		loadData() {
			this.addressId = this.$route.query.id;

			api.order.getAddressDetail(this.addressId, (res) => {
				// debugger
				this.dataList = res.address;
				this.cellChecked = res.address.default;
				this.initialIds = [
					this.dataList.province,
					this.dataList.city,
					this.dataList.district,
					this.dataList.town,
				];
				this.getAreaInfo();
			});
		},
		getAreaInfo() {
			// 获取所有省
			
			// debugger
			this.dataList.province
			let provinceId = this.initialIds[0];
			let cityId = this.initialIds[1];
			let districtId = this.initialIds[2];
			let townId = this.initialIds[3];
			api.product.getAddress(
				1,
				0,
				(data) => {
					this.columns[0].values = [];
					var i = 0;
					for (var n in data.provinces) {
						var c = data.provinces[n];
						if (provinceId == c) {
							this.columns[0].defaultIndex = i;
						}
						this.columns[0].values.push(new AddressItem(n, c));
						i++;
					}

					api.product.getAddress(
						2,
						
						provinceId,
						(data) => {
							this.columns[1].values = [];
							i = 0;
							for (var n in data.provinces) {
								
								var c = data.provinces[n];
								console.log(this.dataList.city)
								if (cityId == c) {
									
									this.columns[1].defaultIndex = i;
								}
								this.columns[1].values.push(new AddressItem(n, c));
								i++;
							}
							api.product.getAddress(
								3,
								cityId,
								(data) => {
									this.columns[2].values = [];
									i = 0;
									for (var n in data.provinces) {
										var c = data.provinces[n];
										if (districtId == c) {
											this.columns[2].defaultIndex = i;
										}
										this.columns[2].values.push(new AddressItem(n, c));
										i++;
									}
									api.product.getAddress(
										4,
										districtId,
										(data) => {
											this.columns[3].values = [];
											i = 0;
											for (var n in data.provinces) {
												var c = data.provinces[n];
												if (this.dataList.town == c) {
													this.columns[3].defaultIndex = i;
												}
												this.columns[3].values.push(new AddressItem(n, c));
												i++;
											}
										},
										(error) => {
											this.$toast(error.msg);
										}
									);
								},
								(error) => {
									this.$toast(error.msg);
								}
							);
						},
						(error) => {
							this.$toast(error.msg);
						}
					);
				},
				(error) => {
					this.$toast(error.msg);
				}
			);
		},
		close() {
			this.ui.show = false;
		},
		showPopup() {
			this.showArea = true;
		},
		onCancel() {
			this.showArea = false;
		},
		onConfirm() {
			var address = this.$refs.areaPick.getValues();
			console.log(address);
			var ids = [];
			var area = '';
			var sarea = '';
			for (var c in address) {
				if (address[c] && typeof address[c] == 'object') {
					area += address[c].name + '-';
					sarea += address[c].name + '|';
					ids.push(address[c].code);
				}
			}

			area = area.substring(0, area.length - 1);
			this.dataList.area = area;
			this.info.sArea = sarea;
			this.ids = ids;
			console.log(this.ids);
			this.showArea = false;
		},
		onChange(picker, values, index) {
			console.log('onChange: ' + index);
			if (index == 0) {
				// 选择第一列
				var provincesId = this.$refs.areaPick.getColumnValue(0).code;
				api.product.getAddress(
					2,
					provincesId,
					(data) => {
						var city = [];
						for (var n in data.provinces) {
							var c = data.provinces[n];
							city.push(new AddressItem(n, c));
						}
						picker.setColumnValues(1, city);
						var cityId = city[0].code;
						api.product.getAddress(
							3,
							cityId,
							(data) => {
								var area = [];
								for (var n in data.provinces) {
									var c = data.provinces[n];
									area.push(new AddressItem(n, c));
								}
								picker.setColumnValues(2, area);
								var areaId = area[0].code;
								api.product.getAddress(
									4,
									areaId,
									(data) => {
										var country = [];
										for (var n in data.provinces) {
											var c = data.provinces[n];
											country.push(new AddressItem(n, c));
										}
										picker.setColumnValues(3, country);
									},
									(error) => {
										this.$toast(error.msg);
									}
								);
							},
							(error) => {
								this.$toast(error.msg);
							}
						);
					},
					(error) => {
						this.$toast(error.msg);
					}
				);
			} else if (index == 1) {
				// 选择第二列
				var cityId = this.$refs.areaPick.getColumnValue(1).code;
				api.product.getAddress(
					3,
					cityId,
					(data) => {
						var area = [];
						for (var n in data.provinces) {
							var c = data.provinces[n];
							area.push(new AddressItem(n, c));
						}
						picker.setColumnValues(2, area);
						var areaId = this.$refs.areaPick.getColumnValue(2).code;
						api.product.getAddress(
							4,
							areaId,
							(data) => {
								var country = [];
								for (var n in data.provinces) {
									var c = data.provinces[n];
									country.push(new AddressItem(n, c));
								}
								picker.setColumnValues(3, country);
							},
							(error) => {
								this.$toast(error.msg);
							}
						);
					},
					(error) => {
						this.$toast(error.msg);
					}
				);
			} else if (index == 2) {
				// 选择第三列
				var areaId = this.$refs.areaPick.getColumnValue(2).code;
				api.product.getAddress(
					4,
					areaId,
					(data) => {
						var country = [];
						for (var n in data.provinces) {
							var c = data.provinces[n];
							country.push(new AddressItem(n, c));
						}
						picker.setColumnValues(3, country);
					},
					(error) => {
						this.$toast(error.msg);
					}
				);
			}
		},
		onSubmit() {
			// debugger
			let area = this.dataList.area;
			let detail = this.dataList.detail;
			let receiver = this.dataList.receiver;
			let telephone = this.dataList.telephone;
			let reg = /^(0|86|17951)?(13[0-9]|14[57]|15[0-9]|16[0-9]|17[678]|18[0-9]|19[0-9])[0-9]{8}$/;
			if (receiver == '') {
				this.$toast('请输入收货人');
				return;
			}
			if (receiver.length > 6) {
				this.$toast('收货人名字不能超过6个字');
				return;
			}
			if (!reg.test(telephone)) {
				this.$toast('请输入正确的手机号码');
				return;
			}
			if (this.ids) {
				var provinceCode = this.ids[0];
				var cityCode = this.ids[1];
				var districtCode = this.ids[2];
				var townCode = this.ids[3] ? this.ids[3] : 0;
			} else {
				// this.ids = this.initialIds;
				var provinceCode = this.initialIds[0];
				var cityCode = this.initialIds[1];
				var districtCode = this.initialIds[2];
				var townCode = this.initialIds[3] ? this.initialIds[3] : 0;
				// this.$toast('请选择地址');
				// return;
			}
			if (this.dataList.detail == '') {
				this.$toast('请输入详细地址');
				return;
			}
			api.order.editAddress(
				this.addressId,
				this.cellChecked,
				provinceCode,
			    cityCode,
				districtCode,
				townCode,
				detail,
				receiver,
				telephone,
				(res) => {
					var cart = this.$route.query.cart;
					this.$toast('修改成功');
					if(cart) {
						this.$router.push('/pages/payment/SelectAddress?cart='+cart);
					}else {
						this.$router.push('/pages/setting/AddressList');
					}
					
				},
				(r) => {
					this.$alertDialog(r.msg);
				}
			);
		},
		noScroll(event) {
			event.preventDefault(); //阻止默认的处理方式(阻止下拉滑动的效果)
		},
	},
	mounted() {
		this.setTitle();
		
		this.loadData();
		// this.getAreaInfo();
		var isIE = function() {
			if (window.navigator.userAgent.indexOf('MSIE') >= 1) {
				//IE < 11
				return true;
			} else {
				if (!!window.ActiveXObject || 'ActiveXObject' in window)
					//IE11的useragent没有MSIE字样，所以只能通过ActiveXObject来识别
					return true;
				else return false;
			}
		};
		this.ui.isIE = isIE();
	},
};
</script>

<style scoped lang="less">
.list {
	background: #fff;
	border-top: 1px solid #f5f5f5;
	padding: 0 4vw;
	font-size: 4vw;
	display: flex;
	align-items: center;
	height: 13.33vw;
	label {
		display: block;
		width: 25vw;
		color: #666;
	}
	input {
		color: #333;
		width: 70%;
	}
	input::-webkit-input-placeholder {
		color: #ccc;
	}
	input[type='text'] {
		padding: 0;
	}
	// #detail {
	// 	width: 70%;
	// }
	.icon {
		width: 3.47vw;
		height: 3.47vw;
		margin: 0;
		position: absolute;
		right: 4.13vw;
	}
}
.flex-wrap {
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.list.pick-area {
	position: relative;
	// justify-content: space-between;
}
.set-default {
	line-height: 13.33vw;

	color: #333;
	margin-top: 2.67vw;
	.van-cell {
		font-size: 4vw;
		height: 13.33vw;
		padding: 0 4vw;
	}
}
.submit-btn {
	width: 89.33vw;
	line-height: 12vw;
	border-radius: 11vw;
	font-size: 4.8vw;
	color: #fff;
	background-image: -webkit-gradient(linear, left top, right top, from(#ff0d33), to(#ff7f5f));
	background-image: -webkit-linear-gradient(left, #ff0d33, #ff7f5f);
	background-image: linear-gradient(to right, #ff0d33, #ff7f5f);
	text-align: center;
	margin: 12vw auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/setting/EditAddress.vue